module.exports = __webpack_public_path__ + "static/media/niyitanga_rushaki2.bf8f273b.jpg";